import React from 'react'
import { FiberManualRecord as StopLightIcon } from '@mui/icons-material'

import { formatDistanceToNow, isValid, differenceInHours } from 'date-fns'
import { capitalize } from 'lodash'
import { Tooltip } from '@mui/material'

const formatDateAge = (
    date?: Date | string | number | null,
): { title: string; color: 'primary' | 'secondary' | 'error' } => {
    const now = new Date()
    const dateToTest = date ? new Date(date) : new Date()
    const ageInHours = differenceInHours(now, dateToTest)

    const title = capitalize(`${formatDistanceToNow(dateToTest)} old`)

    switch (true) {
        case !isValid(dateToTest):
            return { title: 'Error', color: 'error' }
        case ageInHours === 0:
            return { title, color: 'primary' }
        case ageInHours < 12:
            return { title, color: 'secondary' }
        default:
            return { title, color: 'error' }
    }
}

interface Props {
    lastUpdated?: string | null
}

const Stoplight: React.FC<Props> = ({ lastUpdated }: Props) => {
    const { title, color } = formatDateAge(lastUpdated)
    return (
        <Tooltip title={title}>
            <StopLightIcon sx={{ mr: 1 }} fontSize="small" color={color} />
        </Tooltip>
    )
}

export default Stoplight
